/**
 * @Author: wuyang
 * @Date: 2023/12/28
 * @Description: ""
 */
import {
	BaseAtomMethodClass,
	IBaseAtomMethodClassProps,
	IBaseEventMitt
} from '@/helper/base/BaseAtomMethodClass'
import { EventType } from 'mitt'

export interface IBaseAbstractClassProps<
	EventMitt extends IBaseEventMitt = IBaseEventMitt
> extends IBaseAtomMethodClassProps<EventMitt> {
	asyncInit?: boolean
}

interface IBaseAbstractClassDefaultOption
	extends Pick<IBaseAbstractClassProps, 'asyncInit' | 'handleMitt'> {}

enum EBaseClassStatus {
	'INIT' = 'init',
	'NORMAL' = 'normal',
	'DESTORY' = 'destory'
}
export class BaseAbstractClass<
	P extends IBaseAbstractClassProps,
	EventMitt extends Record<EventType, unknown> = any
> extends BaseAtomMethodClass<P, EventMitt> {
	private __initTask__: IPromiseResolversReturn | undefined
	private __status__: EBaseClassStatus = EBaseClassStatus.INIT

	private __options__: IBaseAbstractClassProps
	private __default_options_: IBaseAbstractClassDefaultOption = {
		asyncInit: true,
		handleMitt: {}
	}
	protected constructor(props: P) {
		super(props)
		this.__options__ = Object.assign(this.__default_options_, props)
		if (this.__options__.asyncInit) {
			this.__initTask__ = Promise.withResolvers()
		}
	}

	protected init(props: P) {
		if (this.__options__.asyncInit) {
			this.asyncInit(props)
				.then(() => {
					this.__status__ = EBaseClassStatus.NORMAL
					this.__initTask__?.resolve()
				})
				.catch(this.__initTask__?.reject)
		} else {
			this.syncInit(props)
			this.__status__ = EBaseClassStatus.NORMAL
		}
	}

	// 可被子类复写 函数初始化方法
	public async asyncInit(props: P) {}
	public syncInit(props: P) {}

	// 可被子类复写 函数销毁方法， 记得 super.destory()
	public destory() {
		super.destory()
		this.__initTask__ = undefined
		this.__status__ = EBaseClassStatus.DESTORY
	}

	/**
	 * 当前对象异步控制
	 */
	get initTask() {
		return this.__initTask__!
	}

	/*
	 * 当前状态
	 */
	get status() {
		return this.__status__
	}

	/**
	 * 是否销毁
	 */
	get isDestory() {
		return this.__status__ === EBaseClassStatus.DESTORY
	}
}
